/**
 * Created by federuiz on 7/14/17.
 */
/**
 * @class ErrorCalleSinAlturas
 * @namespace usig
 * @constructor
 * @param {String} str Nombre oficial de la calle
 */
export function ErrorCalleSinAlturas(str) {
    this.id = 3;
    this.message = 'La calle {calle} no posee alturas oficiales. Utilice intersecciones para hallar direcciones v&aacute;lidas sobre esta calle o escriba S/N en lugar de la altura.'

    /**
     * Devuelve un mensaje de error con el nombre de la calle
     * @return {String} Mensaje de error
     */
    this.toString = function() {
        return this.message.replace('{calle}', str);
    };

    /**
     * Devuelve el nombre de la calle
     * @return {String} Nombre de la calle
     */
    this.getNombreCalle = function() {
        return str;
    };

    /**
     * Devuelve un mensaje de error más descriptivo y amigable
     * @return {String} Mensaje de error
     */
    this.getErrorMessage = function() {
        return usig.ErrorCalleSinAlturas.defaults.texts.message.replace('{calle}', str);
    }
}


// WEBPACK FOOTER //
// ./src/ErrorSinAlturas.js